<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-page-header content="支付流水上传"></el-page-header>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <div class="container">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 20px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>支付流水上传与保存</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="header">
          <h1>支付流水数据保存系统</h1>
          <p>注意：请选择正确的代理、支付通道、支付月份。上传Excel/CSV文件并通过API接口保存数据</p>
        </div>
        <div>
          <el-form :model="form" :rules="rules" ref="form" label-width="120px" size="mini">
            <el-form-item label="所属代理商" required >
              <el-input  placeholder="请选择所属代理商" v-model="form.proxy_name" :readonly="true"  @click.native="cProxy" clearable type="text">
                <i slot="suffix" class="el-icon-more"></i>
              </el-input>
            </el-form-item>
            <el-form-item required label="支付月份" >
              <el-date-picker

                      v-model="form.pay_time"
                      type="month"
                      placeholder="请选择支付月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="所属支付渠道" required>
              <el-select
                      v-model="form.pay_source_id"
                      placeholder="请选择所属支付渠道"
                      @change="changeRoleNameValue($event)"
              >
                <el-option v-for="item in paySourceList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="okForm" type="primary" icon="el-icon-edit">确认选择</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="main-content" v-if="is_show">
          <!-- 上传区域 -->
          <div class="upload-section">
            <div class="section-title">
              <i class="el-icon-upload"></i>
              文件上传
            </div>

            <div class="file-type-tabs">
              <div class="file-type-tab" :class="{active: activeTab === 'excel'}" @click="activeTab = 'excel'">Excel上传</div>
              <div class="file-type-tab" :class="{active: activeTab === 'csv'}" @click="activeTab = 'csv'">CSV上传</div>
            </div>

            <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :auto-upload="false"
                    :on-change="handleFileChange"
                    :accept="activeTab === 'excel' ? '.xlsx, .xls' : '.csv'"
                    :limit="1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持{{activeTab === 'excel' ? 'xlsx、xls' : 'csv'}}格式文件</div>
            </el-upload>
            <div class="upload-tips">
              <p>上传说明：</p>
              <p>1. 请确保文件包含支付流水数据</p>
              <p>2. 第一行应为表头（字段名称）</p>
              <p>3. 系统将自动映射到API字段</p>
              <p>4. 支持数据验证和错误处理</p>
            </div>


            <div v-if="file" class="file-info">
              <p>已选择文件: {{ file.name }}</p>
              <p>文件大小: {{ formatFileSize(file.size) }}</p>
              <p>文件类型: {{ file.type || getFileType(file.name) }}</p>
              <p>检测到字段: {{ tableHeader.length }} 个</p>
            </div>

            <div class="action-buttons">
              <el-button type="primary" icon="el-icon-upload" @click="processFile" :disabled="!file">
                处理文件
              </el-button>
              <el-button icon="el-icon-delete" @click="clearData">
                清空数据
              </el-button>
            </div>

            <div v-if="uploadSuccess" class="success-message">
              <i class="el-icon-success"></i>
              <span>文件处理成功！共解析 {{ tableData.length }} 条数据</span>
            </div>
          </div>

          <!-- 预览区域 -->
          <div class="preview-section">
            <div class="section-title">
              <i class="el-icon-document"></i>
              数据预览
            </div>

            <div v-if="tableData.length === 0" class="no-data">
              <i class="el-icon-document"></i>
              <p>暂无数据，请上传{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件</p>
            </div>

            <div v-else>
              <el-table
                      :data="tableData.slice(0, 5)"
                      border
                      stripe
                      class="preview-table"
                      max-height="300"
              >
                <el-table-column
                        v-for="(header, index) in tableHeader"
                        :key="index"
                        :prop="header"
                        :label="header"
                        min-width="120"
                >
                </el-table-column>
              </el-table>

              <div style="margin-top: 15px; text-align: center; color: #909399;" v-if="tableData.length > 5">
                仅显示前5条记录，共 {{ tableData.length }} 条记录
              </div>

              <div class="action-buttons">
                <el-button type="primary" icon="el-icon-download" @click="exportData">
                  导出数据
                </el-button>
                <el-button type="success" icon="el-icon-check" @click="showMappingDialog">
                  配置API映射
                </el-button>
              </div>
            </div>
          </div>

          <!-- API操作区域 -->
          <div class="api-section">
            <div class="section-title">
              <i class="el-icon-connection"></i>
              API接口操作
            </div>

            <div class="api-status">
              <div class="status-indicator" :class="apiConnected ? 'status-connected' : 'status-disconnected'"></div>
              <span v-if="apiConnected">API连接正常 (v1.2.0)</span>
              <span v-else>API未连接</span>
              <el-button size="mini" :type="apiConnected ? 'danger' : 'success'" @click="toggleApiConnection" style="margin-left: auto;">
                {{ apiConnected ? '断开连接' : '连接API' }}
              </el-button>
            </div>

            <div class="api-stats" v-if="apiConnected">
              <div class="stat-card">
                <div class="stat-label">总请求数</div>
                <div class="stat-value">{{ apiStats.totalRequests }}</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">成功请求</div>
                <div class="stat-value">{{ apiStats.successRequests }}</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">失败请求</div>
                <div class="stat-value" :style="{color: apiStats.failedRequests > 0 ? '#f56c6c' : '#67c23a'}">{{ apiStats.failedRequests }}</div>
              </div>
              <div class="stat-card">
                <div class="stat-label">平均响应时间</div>
                <div class="stat-value">{{ apiStats.avgResponseTime }}ms</div>
              </div>
            </div>

            <div class="api-operations" v-if="apiConnected && tableData.length > 0">
              <el-button type="primary" icon="el-icon-edit" @click="showMappingDialog">
                字段映射配置
              </el-button>
              <el-button type="success" icon="el-icon-upload" @click="saveViaApi" :loading="saving">
                {{ saving ? '保存中...' : '通过API保存数据' }}
              </el-button>
              <el-button type="warning" icon="el-icon-view" @click="testApi" :disabled="saving">
                测试API接口
              </el-button>
            </div>

            <div class="api-progress" v-if="saving">
              <el-progress :percentage="saveProgress" ></el-progress>
              <div class="progress-info">
                <span>已处理: {{ processedRecords }}/{{ tableData.length }}</span>
                <span>进度: {{ saveProgress }}%</span>
              </div>
            </div>

            <div class="response-details" v-if="apiResponse">
              <h3>API响应详情</h3>
              <div class="response-item" :class="{'response-error': apiResponse&&apiResponse.status === 'error'}">
                <p><strong>状态:</strong> {{ apiResponse.status||'' }}</p>
                <p><strong>消息:</strong> {{ apiResponse.message }}</p>
                <p v-if="apiResponse.data"><strong>数据:</strong> {{ apiResponse.data.processed }} 条记录已处理</p>
                <p v-if="apiResponse.data"><strong>成功:</strong> {{ apiResponse.data.success }} 条</p>
                <p v-if="apiResponse.data"><strong>失败:</strong> {{ apiResponse.data.failed }} 条</p>
                <p v-if="apiResponse.timestamp"><strong>时间:</strong> {{ apiResponse.timestamp }}</p>
              </div>
            </div>

            <div class="api-log">
              <div v-for="(log, index) in apiLogs" :key="index" class="log-entry" :class="{'log-error': log.type === 'error', 'log-warning': log.type === 'warning'}">
                [{{ log.time }}] {{ log.message }}
              </div>
              <div v-if="apiLogs.length === 0" style="color: #909399; text-align: center; padding: 20px;">
                暂无API日志
              </div>
            </div>
          </div>
        </div>

        <div class="footer">
          <p>© 2025 支付流水数据保存系统 | API版本: v1.2.0</p>
        </div>
      </div>

      <!-- 字段映射对话框 -->
      <el-dialog title="字段映射配置" :visible.sync="mappingDialogVisible" width="800px">
        <div class="data-mapping">
          <p>请将上传文件的字段映射到API接口字段：</p>

          <div v-for="(header, index) in tableHeader" :key="index" class="mapping-row">
            <div class="source-field">{{ header }}</div>
            <div class="mapping-arrow"><i class="el-icon-right"></i></div>
            <el-select v-model="fieldMappings[header]" placeholder="选择API字段" class="target-field">
              <el-option v-for="field in apiFields" :key="field" :label="field" :value="field"></el-option>
            </el-select>
          </div>

          <el-divider></el-divider>

          <h4>API端点配置</h4>
          <el-input v-model="apiEndpoint" placeholder="请输入API端点URL" style="margin-bottom: 15px;">
            <template slot="prepend">API URL</template>
          </el-input>

          <el-input v-model="apiBatchSize" placeholder="请输入批量大小" style="margin-bottom: 15px;">
            <template slot="prepend">批量大小</template>
            <template slot="append">条/请求</template>
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="mappingDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmMapping">确认配置</el-button>
            </span>
      </el-dialog>

    </el-card>
    <eProxyList
            :formData="formData2"
            :visible.sync="visible2"
            :title="title2"
            v-on:eventChoose="chooseProxy"
            :closeForm="closeForm2"
    />
  </div>
</template>
<script>
  // 模拟axios的paySave方法
  // const mockAxios = {
  //   paySave: function(data) {
  //     return new Promise((resolve, reject) => {
  //       // 模拟网络延迟
  //       const delay = Math.random() * 1000 + 500;
  //
  //       setTimeout(() => {
  //         // 模拟90%的成功率
  //         if (Math.random() > 0.1) {
  //           resolve({
  //             status: 'success',
  //             message: '数据保存成功',
  //             data: {
  //               processed: data.length,
  //               success: data.length - Math.floor(Math.random() * 3),
  //               failed: Math.floor(Math.random() * 3)
  //             },
  //             timestamp: new Date().toLocaleString()
  //           });
  //         } else {
  //           reject({
  //             status: 'error',
  //             message: '保存失败：服务器内部错误',
  //             timestamp: new Date().toLocaleString()
  //           });
  //         }
  //       }, delay);
  //     });
  //   }
  // };

  import eProxyList from "../../common/eProxyList"
  import Papa from 'papaparse';
  import * as XLSX from 'xlsx';
  export default {
    name:'uploadPayCsv',
    components: { eProxyList},
    data() {
      return {
        is_show:false,

        paySourceList:[],
        formData2:{pid:''},
        title2:'',
        visible2:false,
        form:{
          proxy_id:'',
          proxy_name:'',
          pay_source_id:'',
          pay_time:''
        },
        rules:{

        },
        file: null,
        tableHeader: [],
        tableData: [],
        uploadSuccess: false,
        activeTab: 'excel',
        apiConnected: true,
        apiStats: {
          totalRequests: 0,
          successRequests: 0,
          failedRequests: 0,
          avgResponseTime: 0
        },
        saving: false,
        saveProgress: 0,
        processedRecords: 0,
        apiLogs: [],
        mappingDialogVisible: false,
        fieldMappings: {},
        apiFields: [
          'cusid', 'service_cusid', 'balance', 'servince_name',
          'merchant', 'paymentMethod', 'customerId',
          'orderId', 'description', 'fee', 'netAmount','amount','trade_time','way_code'
        ],
        apiEndpoint: '/api/payment/save',
        apiBatchSize: 50,
        apiResponse: null
      }
    },
    mounted() {
      // 初始化API日志
      this.addApiLog('系统初始化完成', 'info');
      this.addApiLog('API连接已建立', 'info');
      this.addApiLog('端点: ' + this.apiEndpoint, 'info');
    },
    created() {
      this.getProxyList();
    },
    methods: {
      changeRoleNameValue(e){
       console.log(e)
      },
      okForm(){
        if(this.form.pay_source_id==''){
          this.$message.warning('请选择支付渠道');
          return;
        }
        if(this.form.proxy_id==''){
          this.$message.warning('请选择代理商');
          return;
        }
        if(this.form.pay_time==''){
          this.$message.warning('请选择支付月份');
          return;
        }

        this.is_show=true;
      },
      closeForm2(){
        this.visible2=false;
      },
      cProxy(){
        this.title2="选择所属代理";
        this.visible2=true;
        this.formData2.pid=sessionStorage.getItem('proxy_id');
        console.log( this.formData2.pid)
      },
      chooseProxy(id,...params){
        this.form.proxy_id=id;
        this.form.proxy_name=params[0];
      },
      getProxyList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findPaySourceList(param).then(res=>{
          if(res.code == 200){
            this.paySourceList = res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      formatFileSize(size) {
        if (size < 1024) {
          return size + ' B';
        } else if (size < 1024 * 1024) {
          return (size / 1024).toFixed(2) + ' KB';
        } else if (size < 1024 * 1024 * 1024) {
          return (size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
          return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
        }
      },
      getFileType(filename) {
        const extension = filename.split('.').pop().toLowerCase();
        if (extension === 'xlsx' || extension === 'xls') {
          return 'Excel文件';
        } else if (extension === 'csv') {
          return 'CSV文件';
        }
        return '未知文件类型';
      },
      // 处理文件变化
      handleFileChange(file) {


        this.file = file.raw;
        this.uploadSuccess = false;
        this.tableData = [];

        if (!this.file) {
          this.$message.error('请选择文件');
          return;
        }

        // 解析文件
        this.parseFile();
      },

      // 解析文件
      // 解析文件
      parseFile() {
        const fileReader = new FileReader();
        const fileExtension = this.file.name.split('.').pop().toLowerCase();

        fileReader.onload = (e) => {
          try {
            if (fileExtension === 'csv') {
              // 处理CSV文件
              if (typeof Papa === 'undefined') {
                this.$message.error('CSV解析库未正确加载，请刷新页面重试');
                return;
              }

              const csvData = Papa.parse(e.target.result, {
                header: true,
                skipEmptyLines: true,
                encoding: 'UTF-8'
              });

              if (csvData.data.length > 0) {
                this.tableHeader = Object.keys(csvData.data[0]);
                this.tableData = csvData.data;
                this.uploadSuccess = true;
                this.$message.success('CSV文件解析成功！');
                this.addApiLog(`CSV文件解析成功，共 ${csvData.data.length} 条记录`, 'info');
              } else {
                this.$message.error('CSV文件中没有数据');
                this.addApiLog('CSV文件中没有数据', 'error');
              }
            } else {
              // 处理Excel文件
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, {type: 'array'});

              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              // 转换为JSON
              const jsonData = XLSX.utils.sheet_to_json(worksheet);

              if (jsonData.length > 0) {
                // 获取表头
                this.tableHeader = Object.keys(jsonData[0]);
                this.tableData = jsonData;
                this.uploadSuccess = true;
                this.$message.success('Excel文件解析成功！');
                this.addApiLog(`Excel文件解析成功，共 ${jsonData.length} 条记录`, 'info');
              } else {
                this.$message.error('Excel文件中没有数据');
                this.addApiLog('Excel文件中没有数据', 'error');
              }
            }

            // 初始化字段映射
            this.initFieldMappings();
          } catch (err) {
            console.error(err);
            this.$message.error('文件解析失败：' + err.message);
            this.addApiLog('文件解析失败: ' + err.message, 'error');
          }
        };

        if (fileExtension === 'csv') {
          fileReader.readAsText(this.file, 'UTF-8');
        } else {
          fileReader.readAsArrayBuffer(this.file);
        }
      },

      // 处理文件
      processFile() {
        this.parseFile();
      },

      // 初始化字段映射
      initFieldMappings() {
        this.fieldMappings = {};


        this.tableHeader.forEach(header => {


          // 尝试自动匹配字段
          const lowerHeader = header.toLowerCase();
          if(this.form.pay_source_id==7){//工行支付
            let matchedField = null;
            if (lowerHeader.includes('cusid') || lowerHeader.includes('编号')) {
              matchedField = 'cusid';
            } else if (lowerHeader.includes('service_cusid') || lowerHeader.includes('服务商号')) {
              matchedField = 'service_cusid';
            }  else if (lowerHeader.includes('balance') || lowerHeader.includes('分润')) {
              matchedField = 'balance';
            }
            // else if (lowerHeader.includes('servince_name') || lowerHeader.includes('服务商名称')) {
            //   matchedField = 'servince_name';
            // } else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
            //   matchedField = 'merchant';
            // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
            //   matchedField = 'paymentMethod';
            // }
            this.fieldMappings[header] = matchedField;
          }else if(this.form.pay_source_id==5){//易宝支付
            let matchedField = null;
            // if (lowerHeader.includes('cusid') || lowerHeader.includes('编号')) {
            //   matchedField = 'cusid';
            // } else
              if (lowerHeader.includes('service_cusid') || lowerHeader.includes('商户编号')) {
              matchedField = 'service_cusid';
            }  else if (lowerHeader.includes('balance') || lowerHeader.includes('分润金额')) {
              matchedField = 'balance';
            } else if (lowerHeader.includes('amount') || lowerHeader.includes('交易金额')) {
                matchedField = 'amount';
              } else if (lowerHeader.includes('trade_time') || lowerHeader.includes('交易日期')) {
                matchedField = 'trade_time';
              }
            // else if (lowerHeader.includes('servince_name') || lowerHeader.includes('服务商名称')) {
            //   matchedField = 'servince_name';
            // } else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
            //   matchedField = 'merchant';
            // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
            //   matchedField = 'paymentMethod';
            // }
            this.fieldMappings[header] = matchedField;
          }else if(this.form.pay_source_id==11){//盛付通
              let matchedField = null;
              // if (lowerHeader.includes('cusid') || lowerHeader.includes('编号')) {
              //   matchedField = 'cusid';
              // } else
              if (lowerHeader.includes('service_cusid') || lowerHeader.includes('商户号')) {
                matchedField = 'service_cusid';
              }  else if (lowerHeader.includes('balance') || lowerHeader.includes('收单分润')) {
                matchedField = 'balance';
              } else if (lowerHeader.includes('amount') || lowerHeader.includes('交易金额')) {
                matchedField = 'amount';
              } else if (lowerHeader.includes('trade_time') || lowerHeader.includes('交易时间')) {
                matchedField = 'trade_time';
              }else if (lowerHeader.includes('way_code') || lowerHeader.includes('支付渠道')) {
                matchedField = 'way_code';
              }
              // else if (lowerHeader.includes('servince_name') || lowerHeader.includes('服务商名称')) {
              //   matchedField = 'servince_name';
              // } else if (lowerHeader.includes('merchant') || lowerHeader.includes('商户')) {
              //   matchedField = 'merchant';
              // } else if (lowerHeader.includes('method') || lowerHeader.includes('方式')) {
              //   matchedField = 'paymentMethod';
              // }
              this.fieldMappings[header] = matchedField;
          }

        });
      },

      // 显示字段映射对话框
      showMappingDialog() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可映射');
          return;
        }

        this.mappingDialogVisible = true;
      },

      // 确认字段映射
      confirmMapping() {
        // 检查是否所有字段都已映射
        const unmappedFields = Object.values(this.fieldMappings).filter(value => !value);

        if (unmappedFields.length > 0) {
          this.$message.warning('请映射所有字段');
          return;
        }

        this.mappingDialogVisible = false;
        this.$message.success('字段映射配置已保存');
        this.addApiLog('字段映射配置已保存', 'info');
      },

      // 通过API保存数据
      saveViaApi() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可保存');
          return;
        }
        if(this.form.pay_source_id==''){
          this.$message.warning('请选择支付渠道');
          return;
        }
        if(this.form.proxy_id==''){
          this.$message.warning('请选择代理商');
          return;
        }

          this.apiStats.totalRequests=0;
          this.apiStats.successRequests=0;
          this.apiStats.failedRequests=0;
          this.apiStats.avgResponseTime=0;

        this.saving = true;
        this.saveProgress = 0;
        this.processedRecords = 0;
        this.addApiLog('开始通过API保存数据...', 'info');

        // 将数据转换为API格式
       const apiData = this.formatDataForApi(this.tableData);

        //分批发送数据
        const batchSize = parseInt(this.apiBatchSize) || 50;
        const totalBatches = Math.ceil(apiData.length / batchSize);
        let currentBatch = 0;

        const sendNextBatch = () => {
          if (currentBatch >= totalBatches) {
            this.saving = false;
            this.saveProgress = 100;
            this.$message.success('所有数据已处理完成');
            this.addApiLog('所有数据已处理完成', 'info');
            return;
          }

          const start = currentBatch * batchSize;
          const end = Math.min(start + batchSize, apiData.length);
          const batchData = apiData.slice(start, end);

          this.addApiLog(`发送批次 ${currentBatch + 1}/${totalBatches} (${batchData.length} 条记录)`, 'info');


          // 调用模拟的paySave API  mockAxios.paySave(batchData)
           console.log(batchData)
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            proxy_id:this.form.proxy_id,
            pay_source_id: this.form.pay_source_id,
            data_list:batchData
          }

            if(this.form.pay_time==''||this.form.pay_time==null||this.form.pay_time==undefined){
              this.$message.warning('请选择支付月份');
              return;
            }else{
              param.pay_time=this.form.pay_time;
            }
          this.$axios.payIcbcSaveAll(param)
                  .then(res => {

                    this.processedRecords += batchData.length;
                    this.saveProgress = Math.round((this.processedRecords / this.tableData.length) * 100);
                    // 更新API统计
                    this.apiStats.totalRequests++;
                    this.apiStats.successRequests++;
                   if(res.code==200) {
                     //this.apiResponse = response;

                     // this.apiResponse = {
                     //               status: 'success',
                     //               message: '数据保存成功',
                     //               data: {
                     //                 processed: batchData.length,
                     //                 success: batchData.length,
                     //                 failed:0
                     //               },
                     //      timestamp: new Date().toLocaleString()
                     //  };
                     this.addApiLog(`批次 ${currentBatch + 1} 保存成功: ${res.data.success} 成功, ${res.data.failed} 失败`, 'info');

                   }else{
                     this.addApiLog(`批次 ${currentBatch + 1} 保存失败: ${res.msg}`, 'error');
                     this.$message.error(`批次 ${currentBatch + 1} 保存失败`);
                   }
                    currentBatch++;
                    sendNextBatch();

                  })
                  .catch(error => {
                    this.apiResponse = error;
                    this.apiResponse = {
                      status: 'error',
                      message:error.msg,
                      timestamp: new Date().toLocaleString()
                    };

                    // // 更新API统计
                    this.apiStats.totalRequests++;
                    this.apiStats.failedRequests++;

                    this.addApiLog(`批次 ${currentBatch + 1} 保存失败: ${error.message}`, 'error');
                    this.$message.error(`批次 ${currentBatch + 1} 保存失败`);

                    // 继续下一批处理
                    currentBatch++;
                    sendNextBatch();
                  });
        };

        // 开始处理第一批
        sendNextBatch();
      },

      // 将数据格式化为API所需格式
      formatDataForApi(data) {
        return data.map(item => {
          const apiItem = {};

          // 根据字段映射转换数据
          for (const sourceField in this.fieldMappings) {
            const targetField = this.fieldMappings[sourceField];
            if (targetField && item[sourceField] !== undefined) {
              apiItem[targetField] = item[sourceField];
            }
          }

          return apiItem;
        });
      },

      // 测试API接口
      testApi() {
        this.addApiLog('测试API接口连接...', 'info');

        // 模拟API测试
        setTimeout(() => {
          this.addApiLog('API接口测试成功', 'info');
          this.$message.success('API接口测试成功');
        }, 800);
      },

      // 切换API连接状态
      toggleApiConnection() {
        this.apiConnected = !this.apiConnected;

        if (this.apiConnected) {
          this.$message.success('API连接已建立');
          this.addApiLog('API连接已建立', 'info');
        } else {
          this.$message.warning('API连接已断开');
          this.addApiLog('API连接已断开', 'warning');
        }
      },

      // 添加API日志
      addApiLog(message, type = 'info') {
        this.apiLogs.unshift({
          time: new Date().toLocaleTimeString(),
          message: message,
          type: type
        });

        // 限制日志数量
        if (this.apiLogs.length > 50) {
          this.apiLogs = this.apiLogs.slice(0, 50);
        }
      },

      // 导出数据
      exportData() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可导出');
          return;
        }

        // 创建工作簿
        const worksheet = XLSX.utils.json_to_sheet(this.tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "支付流水数据");

        // 生成Excel文件并下载
        XLSX.writeFile(workbook, "支付流水数据.xlsx");
        this.$message.success('数据导出成功！');
        this.addApiLog('数据已导出到Excel文件', 'info');
      },

      // 清空数据
      clearData() {
        this.$confirm('确定要清空所有数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData = [];
          this.tableHeader = [];
          this.uploadSuccess = false;
          this.file = null;
          this.apiResponse = null;
          this.$message.info('已清空数据');
          this.addApiLog('已清空上传的数据', 'info');
        }).catch(() => {
          this.$message.info('已取消清空操作');
        });
      }
    }

  };
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  }

  body {
    background-color: #f5f7fa;
    color: #606266;
    padding: 20px;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .header {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
    border-radius: 8px;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header h1 {
    font-size: 28px;
    margin-bottom: 10px;
  }

  .header p {
    font-size: 16px;
    opacity: 0.9;
  }

  .main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
  }

  .upload-section, .preview-section, .api-section {
    flex: 1;
    min-width: 300px;
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .api-section {
    min-width: 100%;
  }

  .section-title {
    font-size: 18px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    color: #67c23a;
    display: flex;
    align-items: center;
  }

  .section-title i {
    margin-right: 10px;
  }

  .upload-demo {
    text-align: center;
  }

  .el-upload-dragger {
    width: 100% !important;
    padding: 20px;
  }

  .upload-tips {
    margin-top: 15px;
    color: #909399;
    font-size: 14px;
    line-height: 1.6;
  }

  .upload-tips p:first-child {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .preview-table {
    margin-top: 20px;
    width: 100%;
  }

  .action-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  .footer {
    margin-top: 30px;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  .no-data {
    text-align: center;
    padding: 40px 0;
    color: #909399;
  }

  .no-data i {
    font-size: 60px;
    margin-bottom: 15px;
    display: block;
    color: #ebeef5;
  }

  .success-message {
    background-color: #f0f9eb;
    color: #67c23a;
    padding: 15px;
    border-radius: 4px;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }

  .success-message i {
    margin-right: 10px;
    font-size: 18px;
  }

  .file-info {
    margin-top: 15px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
  }

  .api-panel {
    margin-top: 20px;
  }

  .api-status {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 4px;
    background-color: #f5f7fa;
  }

  .status-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .status-connected {
    background-color: #67c23a;
  }

  .status-disconnected {
    background-color: #f56c6c;
  }

  .api-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin: 20px 0;
  }

  .stat-card {
    flex: 1;
    min-width: 150px;
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .stat-value {
    font-size: 24px;
    font-weight: bold;
    color: #67c23a;
    margin: 10px 0;
  }

  .stat-label {
    font-size: 14px;
    color: #909399;
  }

  .api-operations {
    margin-top: 20px;
  }

  .api-log {
    margin-top: 20px;
    max-height: 200px;
    overflow-y: auto;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-family: monospace;
    font-size: 13px;
  }

  .log-entry {
    margin-bottom: 5px;
    padding: 5px;
    border-left: 3px solid #67c23a;
    background-color: white;
  }

  .log-error {
    border-left-color: #f56c6c;
    color: #f56c6c;
  }

  .log-warning {
    border-left-color: #e6a23c;
    color: #e6a23c;
  }

  .api-progress {
    margin-top: 20px;
  }

  .progress-info {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

    .action-buttons {
      flex-direction: column;
      align-items: center;
    }

    .action-buttons .el-button {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .file-type-tabs {
    display: flex;
    margin-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
  }

  .file-type-tab {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
  }

  .file-type-tab.active {
    color: #67c23a;
    border-bottom: 2px solid #67c23a;
    font-weight: 500;
  }

  .data-mapping {
    margin-top: 20px;
  }

  .mapping-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .source-field, .target-field {
    flex: 1;
    padding: 8px;
    background: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .mapping-arrow {
    margin: 0 15px;
    color: #67c23a;
  }

  .response-details {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .response-item {
    margin-bottom: 10px;
    padding: 10px;
    background: white;
    border-radius: 4px;
    border-left: 3px solid #67c23a;
  }

  .response-error {
    border-left-color: #f56c6c;
  }
</style>
